import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchJobsTrafficSplitEligibility } from '../reducers/jobs-traffic-split';
import {
    getJobsTrafficSplitUrl,
    type JobsTrafficSplitDestination,
} from '../util/jobs-traffic-split';

type State = {
    baseConfig?: {
        buyerUrl?: string;
    };
    jobsTrafficSplit?: {
        status?: 'idle' | 'loading' | 'loaded';
        eligible?: boolean;
    };
};

export function useJobsTrafficSplitUrl(
    fallbackUrl: string,
    destination?: JobsTrafficSplitDestination
): string {
    const dispatch = useDispatch();
    const { buyerUrl, eligible, status } = useSelector((state: State) => ({
        buyerUrl: state.baseConfig?.buyerUrl,
        eligible: state.jobsTrafficSplit?.eligible === true,
        status: state.jobsTrafficSplit?.status ?? 'idle',
    }));

    useEffect(() => {
        if (status === 'idle') {
            dispatch(fetchJobsTrafficSplitEligibility() as any);
        }
    }, [dispatch, status]);

    return getJobsTrafficSplitUrl({ buyerUrl, eligible, fallbackUrl, destination });
}
